@if ((ready && tableData && tableData.length > 0) || !config.hideEmptyResult) {
    <div class="detail-page-card" [attr.data-uiid]="config.uiid">
        @if (!config.hideHeader) {
            <div class="detail-page-card-title">
                {{ config.name }}
            </div>
        }
        <div class="detail-page-card-actions">
            <div class="left-side">
                @if (config.allowAdd && !config.hideAddButton) {
                    <button
                        [attr.data-uiid]="config.uiidAdd"
                        class="btn btn-raised"
                        (click)="addRow()"
                        [disabled]="!ready && !config.addOverride"
                    >
                        <i class="fas fa-plus-circle"></i>
                        <span title="{{ config.addButtonTooltip }}">{{
                            "genericListManager.add" | transloco
                        }}</span>
                    </button>
                }
                @if (config.allowDelete && !config.hideDeleteButton) {
                    <button
                        [attr.data-uiid]="config.uiidDelete"
                        class="btn btn-raised red"
                        (click)="deleteRow(activeRow)"
                        [disabled]="!activeRow"
                    >
                        <i class="fas fa-trash"></i>
                        <span>{{ "genericListManager.delete" | transloco }}</span>
                    </button>
                }
                @if (config.allowLink && !config.hideLinkButton) {
                    <button class="btn btn-raised blue" (click)="openLinkModal()">
                        <i class="fas fa-link"></i>
                        <span>{{ "genericListManager.link" | transloco }}</span>
                    </button>
                }

                @if (config.extraButtons) {
                    @for (btn of config.extraButtons; track btn) {
                        <button
                            [attr.data-uiid]="btn.uiid"
                            type="button"
                            [ngClass]="btn.class"
                            (click)="btn.action(activeRow)"
                            [hidden]="!btn.show"
                        >
                            @if (btn.icon) {
                                <cerrix-icon-viewer
                                    [icon]="btn.icon"
                                    [defaultColor]="btn.iconColor"
                                ></cerrix-icon-viewer>
                            }
                            <span class="d-none d-lg-inline ms-2">{{ btn.text }}</span>
                        </button>
                    }
                }
            </div>
            <div class="right-side">
                @if (config.dataMethod && !config.hideRefreshButton) {
                    @let reloadConfirmTitle = "genericListManager.reloadConfirmTitle" | transloco;
                    @let reloadConfirmBody =
                        "genericListManager.reloadConfirmBody" | transloco: { name: config.name };
                    <button
                        [attr.data-uiid]="config.uiidReload"
                        class="btn btn-raised green"
                        (click)="loadPage(reloadConfirmTitle, reloadConfirmBody)"
                    >
                        <i class="fas fa-sync"></i>
                        <span>{{ "genericListManager.reload" | transloco }}</span>
                    </button>
                }
                @if (config.showToolbarSearch) {
                    <input
                        type="text"
                        class="form-control"
                        [placeholder]="'genericListManager.searchPlaceholder' | transloco"
                        (debounce-input-event)="config.onSearch($event)"
                        inputTooltip
                    />
                }
            </div>
        </div>

        @if (ready && (!tableData || tableData.length == 0) && !config.hideEmptyResult) {
            <div class="detail-page-card-body padded">
                @if (config.emptyMessage) {
                    <small>{{ config.emptyMessage }}</small>
                } @else {
                    <small>{{
                        "genericListManager.emptyList"
                            | transloco: { name: (config.name | lowercase) }
                    }}</small>
                    @if (config.allowAdd) {
                        <small
                            [innerHTML]="'genericListManager.clickAddHint' | transloco"
                        ></small>
                    }
                }
            </div>
        } @else if (!ready) {
            <div class="detail-page-card-body padded cerrix-control-sm">
                <div class="fancy-loader submodule"></div>
            </div>
        }

        @if (scopedTableData && scopedTableData.length > 0) {
            <div class="detail-page-card-body overflow-auto">
                @if (tableData) {
                    <cerrix-table
                        [config]="config"
                        [data]="scopedTableData"
                        [idProp]="idProp"
                        [activeRow]="activeRow"
                        (activeRowChange)="activeRow = $event"
                        (rowClick)="singleClick(activeRow)"
                        (rowDblClick)="editRow(activeRow)"
                        (sortingChanged)="sortingChanged()"
                        [rendererConfig]="config.rendererConfig"
                        [NoPadding]="true"
                        [NoBorder]="true"
                        [Centered]="true"
                    ></cerrix-table>
                }

                @if (scopedToggleAllowed) {
                    <div class="custom-pagination" (click)="toggleScopedTableData()">
                        {{
                            (scopedTableExpanded
                                ? "genericListManager.viewLast"
                                : "genericListManager.viewAll"
                            )
                                | transloco
                                    : {
                                          count: scopedTableExpanded
                                              ? config.limitViewTo
                                              : config._visibleRowCount
                                      }
                        }}
                    </div>
                }
            </div>
        }
    </div>
}

<ng-template #linkable></ng-template>

<generic-form-editor
    [config]="config"
    [additionalData]="additionalData"
    (change)="applyRowChange($event)"
    #editorCmp
>
</generic-form-editor>
